"use client";
import { ProductJson } from "@/types/Product.type";
import React, { useEffect, useMemo, useState } from "react";
import StoreList from "~components/stores/StoreList";
import ProductSinglePrice from "~components/product/ProductSinglePrice";
import ProductStatus from "~components/product/ProductStatus";
import WishlistBtn from "~components/wishlist/WishlistBtn";
import ShareIcon from "@/components/icons/ShareIcon";
import ProductTags from "~components/product/ProductTags";
import AddToCartBtn from "~components/cart/AddToCartBtn";
import ProductSelectQuantity from "~components/product/ProductSelectQuantity";
import ProductBtnSendMail from "~components/product/ProductBtnSendMail";
import Money from "@/components/ui/Money";
import ProductPercentSale from "~components/product/ProductPercentSale";
import useDealthom from "@/lib/hooks/useDealthom";

interface ProductActionsMobileProps {
	productVariant: ProductJson;
	product: ProductJson;
	store_id: number;
}

function ProductActionsMobile({
	productVariant,
	product,
	store_id,
}: ProductActionsMobileProps) {
	const [quantity, setQuantity] = useState(1);
	const { promotionsHaveConfig } = useDealthom(productVariant);

	//process
	const isOutOfStock = useMemo(() => {
		return productVariant.quantity <= 0;
	}, [productVariant.quantity]);

	async function handleShare() {
		try {
			const shareData = {
				title: product.name,
				url: `${process.env.DOMAIN}/products/${product.handle}`,
			};
			if (navigator.share) {
				await navigator.share(shareData);
			}
		} catch (error) {
			alert("Chức năng hiện không hỗ trợ trên thiết bị của bạn");
		}
	}
	const isPromotions = promotionsHaveConfig.length > 0;
	const { pricePreview, ...productOrigin } = productVariant;

	//init
	useEffect(() => {
		setQuantity(1);
	}, [productVariant]);

	return (
		<>
			{isPromotions && (
				<>
					<div className="flex flex-col gap-2">
						{promotionsHaveConfig.map((p) => {
							return (
								<>
									{p.codes ? (
										<>
											<div
												key={p.id}
												className={`bg-[#F6E9E9]  p-4 m-0 cursor-pointer border-solid even:border-t-2 even:border-red-500`}>
												<div>
													<span className=" text-red-500  text-base font-bold">
														<span className=" uppercase">
															{p.campaign_info.name}:{" "}
														</span>

														<Money
															className="font-bold"
															value={p.promotion_price}></Money>
													</span>
												</div>

												<div className="">
													<span className=" text-gray-500 text-sm">
														Giảm thêm {p.discount_value}% Nhập code{" "}
														<b className="   text-sm  text-blue-500  cursor-pointer">
															{p.codes.map((code) => code.code).join(", ")}
														</b>
													</span>
												</div>
											</div>
										</>
									) : (
										<>
											<div
												key={p.id}
												className={`bg-[#F6E9E9] p-4 m-0 cursor-pointer border-solid even:border-t-2 even:border-red-500`}>
												<div>
													<span className="  text-red-500  text-base font-bold">
														<span className=" uppercase">
															{p.campaign_info.name}:{" "}
														</span>
														<Money
															value={p.promotion_price}
															className=" font-bold"></Money>
													</span>
												</div>
												<div className="">
													<span className=" text-gray-500 text-sm">
														Giảm thêm {p.discount_value}%
													</span>
												</div>
											</div>
										</>
									)}
								</>
							);
						})}
					</div>
				</>
			)}

			<div className="px-4 py-3">
				<div className="flex mb-2 justify-between items-center">
					<ProductStatus isOutOfStock={isOutOfStock} />
					<div className="flex gap-[14px]">
						<button onClick={handleShare}>
							<ShareIcon />
						</button>
						<WishlistBtn
							model={{
								item_id: product.parent_id > 0 ? product.parent_id : product.id,
								item_type: 1,
								item_url: product.handle,
							}}
						/>
					</div>
				</div>

				<div className=" flex gap-1">
					<ProductSinglePrice
						productVariant={{
							...productOrigin,
							pricePreview: null,
						}}
						className="gap-2 flex-row-reverse md:flex-row "
						classNamePrice="text-lg"
						classNameDiscount="text-base"
						classNamePriceCompare=" leading-none text-base text-gray-400 font-normal"
					/>
					<ProductPercentSale
						productVariant={{
							...productOrigin,
							pricePreview: null,
						}}
						className=" text-red-500 text-lg"
						text="-"
					/>
				</div>

				<div className="flex gap-2 mb-2 flex-wrap  mt-2 items-center">
					<p className="text-sm">
						{productVariant.option_name
							? productVariant.option_name
							: productVariant.full_name}
					</p>
					<ProductTags tags={productVariant.tags} />
				</div>
				<div className=" mt-2">
					<StoreList product={productVariant} />
				</div>
				<div className="fixed left-0 right-0 bottom-[55px] h-[50px] bg-white px-4 py-2 shadow-sm z-[1002]">
					<div
						className={`flex rounded h-full ${
							!isOutOfStock && "border border-red-500"
						}`}>
						{isOutOfStock ? (
							<ProductBtnSendMail
								productVariantActive={product}
								className="w-full"
							/>
						) : (
							<>
								<ProductSelectQuantity
									quantity={quantity}
									onChangeQuantity={(quan) => setQuantity(quan)}
									max={productVariant.limit_sale}
									maxValid={
										productVariant.actuals?.actual_quantity ||
										productVariant.quantity
									}
								/>
								<AddToCartBtn
									productData={productVariant}
									item_quantity={quantity}
									isCheckInCart={true}
									store_id={store_id}
									className="flex-1 h-full min-h-full border-0  rounded-none text-white flex items-center justify-center text-sm font-medium"
									promotions={
										productVariant.promotions && productVariant.promotions
									}
								/>
								{/* <AddToCartBtn
                  productData={productVariant}
                  item_quantity={quantity}
                  store_id={store_id}
                  mode="buy"
                  promotions={
                    productVariant.promotions && productVariant.promotions
                  }
                  className="flex-1 h-full min-h-full bg-red-500 rounded-none text-white flex items-center justify-center text-sm font-medium"
                /> */}
							</>
						)}
					</div>
				</div>
			</div>
		</>
	);
}

export default ProductActionsMobile;
